"use client";
import React, { useState, useEffect } from 'react';
import './Step0.css';
import PropTypes, { array } from 'prop-types';
import { Button, Select, Input } from 'atm-global-stylish/dist';
import { getToken, removeToken, removeSinisterType, setValidateType } from '../../../utils/claimManager';
import { useNavigate } from 'react-router-dom';
import { Loader, SpanError } from '../../../components';
import { isEmpty } from '../../../utils/functions';
import { INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../../config/constants';

const Step0 = ({
	createStep,
	config,
	formData,
	setFormData,
	onSuccessStep,
	clearInstance
}) => {
	const navigation = useNavigate();
	
	const [options, setOptions] = useState([{ value: '', title: 'El vehiculo asegurado de ATM es*' }]);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [arrayErrors, setArrayErrors] = useState([]);
	
	useEffect(() => {
		if (config?.insured_vehicle_type) {
			setOptions([
				{ value: "", title: "El vehiculo asegurado de ATM es*" },
				...Object.entries(config?.insured_vehicle_type || {}).map(([key, value]) => ({
					value: key,
					title: value
				}))
			]);
		}
	}, [config]);

	useEffect(() => {
		const token = getToken();
		if (!token) {
			clearInstance();
		}
	}, []);

	const handleValidation = async (type) => {
		let arrayErrorsAux = [];
		setLoading(true);
		try {
			if (type === 1 && (!formData.sinister_number || !formData.branch)) {
				if (isEmpty(formData.sinister_number)) {
					arrayErrorsAux['sinister_number'] = 'Debe ingresar un número de siniestro válido';
				}

				if (isEmpty(formData.branch)) {
					arrayErrorsAux['branch'] = 'Debe ingresar un tipo de vehículo válido';
				}
				
				setArrayErrors(arrayErrorsAux);
				setError(true);
				return;
			}
			const created = await createStep();
			
			if (created) {
				setArrayErrors(arrayErrorsAux);
				const token = getToken();
				if (token) {
					setValidateType(type);
					onSuccessStep(type === 1 ? 2 : 1);
				}
			}
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}

	};

	const handleBack = () => {
		removeSinisterType();
		removeToken();
		navigation('/');
	}
	if(!formData) return;
	return (
		<div className={"step1 w-full items-center justify-center px-5 md:px-0"}>
			<div className={"flex flex-col items-center justify-center mt-11 gap-10"}>
				<p className={"text-3xl text-red font-medium block text-center mt-3"}>
					Ahora comenzamos con la carga de tu reclamo como tercero
				</p>
				{loading ? <Loader /> :
					<div className='w-full md:w-1/3 flex flex-col justify-center items-center gap-5'>
						{options.length > 0 && (
							<div className="flex flex-col w-full">
								<Select
									onChange={(e) => { setArrayErrors((prev) => ({...prev, branch: null})); setFormData(({ ...formData, branch: e.target.value })) }}
									selectedValue={formData.branch}
									list={options}
									className={`${SELECT_CLASSNAME} text-grey-tx`}
									required
								/>
								{
									arrayErrors?.branch && (<SpanError text={arrayErrors.branch} />)
								}
							</div>
						)}
						<div className="flex flex-col w-full">
							<Input
								type='number'
								value={formData.sinister_number}
								handleChange={(e) => {
									setArrayErrors((prev) => ({...prev, sinister_number: null}));

									const onlyNumbers = e.target.value.replace(/\D/g, '');

									if (onlyNumbers.length <= 7)
										setFormData(({ ...formData, sinister_number: onlyNumbers }))
									else
										return
								}}
								className={INPUT_CLASSNAME}
								placeholder='Número de siniestro *'
								required
								maxLength={7}
							/>
							{
								arrayErrors?.sinister_number && (<SpanError text={arrayErrors.sinister_number} />)
							}
						</div>
						{error && (
							<p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
						)}
						<Button type='primary' className='p-2 md:p-3 w-full mt-4' title='Comencemos' handleClick={() => handleValidation(1)} />
						<Button type='secondary' className='p-2 md:p-3 w-full border-[2px] border-black' title='No tengo número de siniestro' handleClick={() => handleValidation(2)} />
						<Button type='secondary' className='p-2 md:p-3 w-full border-[2px] border-black' title='Volver' handleClick={() => handleBack(`/`)} />
					</div>
				}
			</div>
		</div>
	);
};

Step0.propTypes = {
	createStep: PropTypes.func,
	config: PropTypes.any,
	loader: PropTypes.bool,
	formData: PropTypes.object,
	setFormData: PropTypes.func,
	fetchSinisterNumber: PropTypes.func,
};

export default Step0;